import React, { Component } from 'react';

export default class KuposCommonLoader extends Component {
  static propTypes = {

  };

  render() {
    return (
      <div className="common-kupos-common-loader">
        <div className="loader-cricle"></div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/common/KuposCommonLoader.js